import { c as _c } from "react-compiler-runtime";
import { createStore as createZustandStore, useStore } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { useShallow } from 'zustand/react/shallow';
export * from 'zustand';
export { useShallow } from 'zustand/react/shallow';
export const createStore = (initializer, options = {}) => {
  const store = createZustandStore()(devtools(subscribeWithSelector(immer(initializer)), options.devtools));
  return store;
};
export const createStoreHooks = useGetStore => {
  const useStateValue = key => {
    "use memo";

    const $ = _c(2);
    let t0;
    if ($[0] !== key) {
      t0 = state => state[key];
      $[0] = key;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return useStore(useGetStore(), t0);
  };
  const useSelectorValue = selector => {
    "use memo";

    return useStore(useGetStore(), selector);
  };
  const useShallowSelectorValue = selector => {
    "use memo";

    return useStore(useGetStore(), useShallow(selector));
  };
  const useActions = () => {
    "use memo";

    return useGetStore().actions;
  };
  return {
    useStateValue,
    useSelectorValue,
    useShallowSelectorValue,
    useActions
  };
};